import { create } from "sheetly";
export let text = "button.nav-link{height:100%;display:flex;align-items:center;gap:.25em}svg{width:1em;height:1em;fill:var(--bs-body-color)}svg.github-link{width:1.5em;height:1.5em}";
export const sheet = create(text, import.meta.url);
